module.exports = __webpack_public_path__ + "img/1.ba2b27c6.png";